export const postToggle = {
  mounted(el, binding) {
    const targetId = binding.value;
    
    const handleClick = (event) => {
      event.preventDefault();
      
      if (window.collapseElements && window.collapseElements[targetId]) {
        window.collapseElements[targetId].toggle();
      }
    };
    
    el.addEventListener('click', handleClick);
    el._postToggleHandler = handleClick;
  },
  
  beforeUnmount(el) {
    if (el._postToggleHandler) {
      el.removeEventListener('click', el._postToggleHandler);
      delete el._postToggleHandler;
    }
  }
};